import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number as INR using the Indian numbering system (lakh / crore).
 * e.g. 19357692 -> "₹1.94 Cr", 250000 -> "₹2.50 L", 4200 -> "₹4,200"
 */
export function formatINR(value: number | null | undefined): string {
  const n = Number(value || 0)
  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(n)
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(2)} Cr`
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(2)} L`
  // Whole rupees below a lakh — paise in the middle of a Cr/L column read as a
  // different order of magnitude ("₹33,669.33" next to "₹3.49 L").
  return `${sign}₹${Math.round(abs).toLocaleString('en-IN')}`
}

/** Full INR amount with Indian grouping, no abbreviation. e.g. "₹1,93,57,692" */
export function formatINRFull(value: number | null | undefined): string {
  const n = Math.round(Number(value || 0))
  const sign = n < 0 ? '-' : ''
  return `${sign}₹${Math.abs(n).toLocaleString('en-IN')}`
}
